import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import * as _ from 'lodash'
import { BehaviorSubject } from 'rxjs'
import { environment } from '../../../environments/environment'
import { MinimizeTab } from '../../Interfaces/MinimizeTab'
import { Panier,PanierLine } from '../../Interfaces/Panier'

import { PageRoute } from '../../Interfaces/PageRoute'

@Injectable({
    providedIn: 'root'
})
export class StateService {

    demande: any = new BehaviorSubject("");
    demandeType: any = new BehaviorSubject("");
    dossier: any = new BehaviorSubject("");
    dossierWebamat: any = new BehaviorSubject("");
    quickmenu: any = new BehaviorSubject("");
    etats: any = new BehaviorSubject("");
    filters: any = new BehaviorSubject("");
    editForm: any = new BehaviorSubject("");
    pages: any = new BehaviorSubject("");
    notifications: any = new BehaviorSubject("");
    refresh: any = new BehaviorSubject("");
    droitsApp: any = new BehaviorSubject("");
    contactTypes: any = new BehaviorSubject("");
    zoneTypes:any = new BehaviorSubject("");
    user: any = new BehaviorSubject("");
    online: any = new BehaviorSubject(true);
    components: any = new BehaviorSubject([]);
    instrucSelected: any = null;
    loadCreated: boolean = false;
    subHeader: any = new BehaviorSubject("");
    consultation: any = new BehaviorSubject("");
    currentPage: any = new BehaviorSubject("");
    private visiteReload: any = new BehaviorSubject(false);
    reloadVisiteData = this.visiteReload.asObservable();
    public _notifications: any = this.notifications.asObservable();
    refreshAll: BehaviorSubject<boolean> = new BehaviorSubject(false);
    documents: BehaviorSubject<boolean> = new BehaviorSubject(false);
    courriers: BehaviorSubject<boolean> = new BehaviorSubject(false);
    formulaires: BehaviorSubject<boolean> = new BehaviorSubject(false);
    miniminzeTabs: BehaviorSubject<MinimizeTab[]> = new BehaviorSubject([]);
    observedField:any = new BehaviorSubject("");
    reloadPanier:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    PanierGet:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    resetP:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    panier: BehaviorSubject<Panier> = new BehaviorSubject(new Panier());
    
    
     mesvaccins:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    route: BehaviorSubject<PageRoute> = new BehaviorSubject(new PageRoute());

    searchOptions:any = new BehaviorSubject({});
	
	application:any = new BehaviorSubject("");

    alertes: BehaviorSubject<boolean> = new BehaviorSubject(false);
    
	justConnected:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	
	versions:BehaviorSubject<any> = new BehaviorSubject({});
	
	ia:BehaviorSubject<any> = new BehaviorSubject({service: false,user:{}});
	
	menu:BehaviorSubject<any> = new BehaviorSubject({});
	isCropped:BehaviorSubject<boolean> = new BehaviorSubject(false);
	
	icon: any = new BehaviorSubject("la la-user");
	type_tiers:BehaviorSubject<any> = new BehaviorSubject({});
	
	openid: BehaviorSubject<boolean> = new BehaviorSubject(false);
		
	
    constructor(
        private http: HttpClient
    ) { }

    updateDemande(demande: any) {
        this.demande.next(demande)
    }
    updateDroitsApp(droits: any) {
        this.droitsApp.next(droits)
    }
    updateDemandeType(demandeTypes: any) {
        this.demandeType.next(demandeTypes)
    }
    updateDossier(dossier: any) {
        this.dossier.next(dossier)
    }
    updateDossierWebamat(dossier: any) {
        this.dossierWebamat.next(dossier)
    }
    updateStateQuickmenu(state: any) {
        this.quickmenu.next(state)
    }

    updateEtatsDemande(etats: any) {
        this.etats.next(etats)
    }

    updateFilters(filters: any) {
        this.filters.next(filters)
    }

    updateEditForm(edit: any) {
        this.editForm.next(edit)
    }
    updateRefresh(refresh: any) {
        this.refresh.next(refresh)
    }
    updateNotifications(notifications: any) {
        let notifGroupByAlerts = _.groupBy(notifications, o => o.etat === 1 && (o.notificationType === "ALERT" || o.notificationType === "LATE"))
        let notifGroupByNotifications = _.groupBy(notifications, o => o.etat === 1 && o.notificationType !== "ALERT" && o.notificationType !== "LATE")
        let notifGroupByAfaire = _.groupBy(notifications, o => o.etat === 2)
        let notifreturn = {
            alerts: notifGroupByAlerts.true ? notifGroupByAlerts.true : [],
            notifications: notifGroupByNotifications.true ? notifGroupByNotifications.true : [],
            afaire: notifGroupByAfaire.true ? notifGroupByAfaire.true : []
        }
        this.notifications.next(notifreturn)
    }

    updatePages(pages: any) {
        this.pages.next(pages)
    }

    updateContactTypes(contacts: any) {
        this.contactTypes.next(contacts)
    }
    
    updateZoneTypes(zone:any){
        this.zoneTypes.next(zone);
    }
    
    updateUser(user: any) {
        this.user.next(user)
    }

    updateComponents(components: any) {
        this.components.next(components)
    }

    updateOnline(online: boolean) {
        if (online)
            environment.webservice = "/webservice/"
        else
            environment.webservice = "offline/"
        this.online.next(online)
    }

    updateSubHeader(header: string) {
        this.subHeader.next(header)
    }

    selectNewCreatedInstruction(instruc: any) {
        this.instrucSelected = instruc
        this.loadCreated = true
    }

    updateConsultation(consultation: any) {
        this.consultation.next(consultation)
    }
    updateCurrentPage(page: string) {
        this.currentPage.next(page)
    }
    updateVisiteReload(state: boolean) {
        this.visiteReload.next(state)
    }
    
    updateObservedField(fiedls:any) {
        this.observedField.next(fiedls)
    }
    
    updateRefreshAll(state: boolean) {
        this.refreshAll.next(state)
    }
    documentsUpdate(state: boolean) {
        this.documents.next(state)
    }
    courriersUpdate(state: boolean) {
        this.courriers.next(state)
    }
    formulairesUpdate(state: boolean) {
        this.formulaires.next(state)
    }

    addMinimizeTab(tab: MinimizeTab) {
        let tabs = this.miniminzeTabs.getValue()
        tabs.push(tab)
        this.miniminzeTabs.next(tabs)
    }
    removeMinimizeTab(tab: MinimizeTab) {
        let tabs = this.miniminzeTabs.getValue()
        if (tabs.indexOf(tab) !== -1) {
            tabs.splice(tabs.indexOf(tab), 1)
        }
        this.miniminzeTabs.next(tabs)
    }
    
    addPanierLine(line:PanierLine) {
		var panier=	this.panier.getValue();
	   panier.addLine(line);
	   this.panier.next(panier);
	}
	
	removePanierLine(line:PanierLine) {
	    var panier=	this.panier.getValue();
	    panier.removeLine(line);
	    this.panier.next(panier);
	}

    /*updatePanier(status:boolean,bool:boolean, reset:boolean){
        this.reloadPanier.next(status);
        this.PanierGet.next(bool);
        this.resetP.next(reset);
    }*/

    updateMesVaccin(service:boolean){
        this.mesvaccins.next(service);
    }
    
    setRoute(route:PageRoute) {
		var r=this.route.getValue();
		//console.log('StateService Page route0',r,route)
		if ( r.route!=route.route)
			route.pred=r;
		//console.log('StateService Page route1',r,route)
		this.route.next(route);
	}
	
	getCurrentRoute() {
		return  this.route.getValue();
	}

    setSearchOptions(searchOpts:any,searchType:string){
        var currentSearchOptions = this.searchOptions.getValue();
        currentSearchOptions[searchType] = searchOpts;
        this.searchOptions.next(currentSearchOptions);
    }

    getSearchOptions(searchType:string){
        var currentSearchOptions = this.searchOptions.getValue();
        return currentSearchOptions[searchType] != undefined? currentSearchOptions[searchType]: null;
    }
	
	updateApplication(app: any){
	        this.application.next(app);
	     
	    }
    
    alertesUpdate(state: boolean) {
        this.alertes.next(state)
    }
	
	justConnectedUpdate(connected: boolean) {
	        this.justConnected.next(connected)
	}


	updateVersions(version: any) {
	       this.versions.next(version)
	 }
	 
	 getVersions() {
	 		return  this.versions.getValue();
	 }
	 
	 updateIA(ia: any) {
	 	  this.ia.next(ia);
	 }
	 	 
	 getIA() {
	 	 return  this.ia.getValue();
	 }
	 
	 
	 updateMenu(menu: any) {
	 	 	  this.menu.next(menu);
	 	 }
	 	 	 
 	 getMenu() {
 	 	 return  this.menu.getValue();
 	 }
	 
	 cropped(isCropped:boolean=false) {
	 	 	this.isCropped.next(isCropped);
	 }
	 
	 updateIcon(icon: any) {
	  	 	  this.icon.next(icon);
	  	 }
	  	 	 
	 getIcon() {
	 	 return  this.icon.getValue();
	 }
	 
	 updateTypeTiers(atypeTiers: any) {
	 		let att:any={}
	 		if (atypeTiers.length>0) 
	 			for(var i=0;i<atypeTiers.length;i++) {
	 		       let tt=atypeTiers[i];
	 			   if (tt["code"]!=undefined)
	 				att[tt["code"]]=tt;
	 			}
	 				
	 			
	 		
	 	 	 this.type_tiers.next(att);
	 	 }
	 	 		 	 	 
 	  getTypeTiers() {
 	  	 	 return  this.menu.getValue();
 	 }
	 
	 updateOpenID(openid: boolean) {
	  	  this.openid.next(openid);
	  }
	  	 
	  getOpenID() {
	  	 return  this.openid.getValue();
	  }
	 	 	 	
}